// 处理当前用户手动折扣数据去做运用
class CartCoupons extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      form: 'form[data-checkout-form]',
      checkoutBtn: 'button[name="checkout"]',
    };
  }
  connectedCallback() {
    this.isLogin = !!this.dataset.isLogin;
    if (!this.isLogin) return;
    GkifyEvents.subscribe('InteractionTriggeredTask', () => {
      this.init();
    });
  }
  init() {
    this.domNodes = queryDomNodes(this.selectors, this);
    this.getDiscount();
    this.eventClick();
    this.updateCart();
  }
  updateCart() {
    let cartUpdateUnSubscriber = GkifyEvents.subscribe(GkifyTheme.pubSubEvents.cartUpdate, (response) => {
      if (cartUpdateUnSubscriber) cartUpdateUnSubscriber();
      this.removeEventListener();
      this.init();
    });
  }
  eventClick() {
    this.domNodes.checkoutBtn.addEventListener('click', this.checkoutHandle.bind(this));
  }
checkoutHandle(e) {
  e.stopPropagation();
  e.preventDefault();

  const discountInput = this.querySelector('input[name="discount"]');

  if (!discountInput) {
    console.warn('Discount input not found');

    const triggerButton = document.createElement('button');
    triggerButton.type = 'submit';
    triggerButton.name = 'checkout';

    this.domNodes.form.appendChild(triggerButton);
    triggerButton.click();

    return;
  }

  let discountCode = discountInput.value || '';

  let discounts = this.getDiscountByCodes() || [];

  discountCode = discountCode
    ? discountCode.split(',')
    : [];

  let resultDiscount = [...new Set([
    ...discountCode,
    ...discounts
  ])]
    .filter(Boolean)
    .join(',');

  console.log('resultDiscount', resultDiscount);

  discountInput.value = resultDiscount;

  const triggerButton = document.createElement('button');
  triggerButton.type = 'submit';
  triggerButton.name = 'checkout';

  this.domNodes.form.appendChild(triggerButton);
  triggerButton.click();
}
  removeEventListener() {
    this.domNodes.checkoutBtn.removeEventListener('click', this.checkoutHandle.bind(this));
  }
  getDiscount() {
    this.loading();
    let params = new URLSearchParams({ status: 'available', limit: 999, page: 1 });
    fetch(`/apps/esrvip/vip/discounts?${params.toString()}`, {
      ...fetchConfig(),
      method: 'GET',
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this.data = response.data;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally((v) => {
        this.hideLoading();
      });
  }
  loading() {
    this.domNodes.checkoutBtn.classList.add('g-button--loading');
  }
  hideLoading() {
    this.domNodes.checkoutBtn.classList.remove('g-button--loading');
  }
  getDiscountByCodes() {
    if (!this.data) return;
    return this.data.list.map((v) => v.title);
  }
}

customElements.define('g-cart-coupons', CartCoupons);
